import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faDiscord, 
    faGithub, 
    faTwitter 
} from '@fortawesome/free-brands-svg-icons';
import { 
    faEnvelope,
    faLaptopCode,
    faFlagCheckered
} from '@fortawesome/free-solid-svg-icons';
import './Footer.css';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="footer-background">
                <div className="footer-circuit-lines"></div>
                <div className="footer-glow"></div>
            </div>
            
            <Container>
                <Row className="footer-main">
                    {/* Logo & About Section */}
                    <Col lg={4} md={6} className="footer-section">
                        <div className="footer-brand">
                            <img 
                                src="/logo.png" 
                                alt="Fedoraman Project Logo" 
                                className="footer-logo"
                            />
                        </div>
                        <p className="footer-about">
                            A group of ethical pentesters dedicated to learning, sharing knowledge, 
                            and participating in CTF competitions.
                        </p>
                        <div className="footer-social">
                            {/* not available yet
                            <a href="https://discord.gg/fedoramanproject" className="footer-social-link" target="_blank" rel="noopener noreferrer">
                                <FontAwesomeIcon icon={faDiscord} />
                            </a>
                            <a href="https://github.com/fedoramanproject" className="footer-social-link" target="_blank" rel="noopener noreferrer">
                                <FontAwesomeIcon icon={faGithub} />
                            </a>
                            <a href="https://twitter.com/fedoramanproject" className="footer-social-link" target="_blank" rel="noopener noreferrer">
                                <FontAwesomeIcon icon={faTwitter} />
                            </a>
                            */}
                        </div>
                    </Col>

                    {/* Quick Links */}
                    <Col lg={4} md={6} className="footer-section">
                        <h3 className="footer-title">Quick Links</h3>
                        <ul className="footer-links">
                            <li>
                                <FontAwesomeIcon icon={faLaptopCode} className="footer-link-icon" />
                                <a href="/dashboard">Dashboard</a>
                            </li>
                            {/* }
                            <li>
                                <FontAwesomeIcon icon={faFlagCheckered} className="footer-link-icon" />
                                <a href="/ctf">CTF Writeups</a>
                            </li>
                            */}
                            <li>
                                <FontAwesomeIcon icon={faEnvelope} className="footer-link-icon" />
                                <a href="mailto:info@usscfedora.org">Contact Us</a>
                            </li>
                        </ul>
                    </Col>

                    {/* Contact Info */}
                    <Col lg={4} md={12} className="footer-section">
                        <h3 className="footer-title">Contact Us</h3>
                        <div className="footer-contact">
                            <div className="footer-contact-info">
                                <FontAwesomeIcon icon={faEnvelope} className="footer-contact-icon" />
                                <span>info@usscfedora.org</span>
                            </div>
                            {/* commented out for now 
                            <div className="footer-badge">
                                <span>Join Our Community</span>
                                <div className="footer-badge-glow"></div>
                            </div>
                            */}
                        </div>
                    </Col>
                </Row>

                {/* Bottom Bar */}
                <div className="footer-bottom">
                    <div className="footer-line"></div>
                    <Row className="justify-content-between align-items-center">
                        <Col md={6}>
                            <p className="footer-copyright">
                                © {currentYear} FEDORAMAN PROJECT. All rights reserved.
                            </p>
                        </Col>
                        <Col md={6}>
                            <p className="footer-tagline">
                                Securing the Digital Frontier
                            </p>
                        </Col>
                    </Row>
                </div>
            </Container>

            {/* Decorative Elements */}
            <div className="footer-corner footer-corner-left"></div>
            <div className="footer-corner footer-corner-right"></div>
        </footer>
    );
};

export default Footer;